import { ArrowRightAlt } from '@mui/icons-material';
import { Box, Button } from '@mui/material';
import {
  DataGrid, GridColDef, GridColumnHeaderParams, frFR,
} from '@mui/x-data-grid';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAppSelector } from '../store/Hooks';

interface PropsContainer {
    onClick?: any
  }

const MunicipalitiesTable: React.FC<PropsContainer> = ({ onClick }) => {
  const [rows, setRows] = useState([]) as any[];
  const { municipalities } = useAppSelector((state) => state.user);
  const navigate = useNavigate();

  const columns: GridColDef[] = [
    {
      field: 'name',
      headerName: 'Municipalité',
      minWidth: 200,
      flex: 1,
    },
    {
      field: 'link',
      width: 200,
      disableColumnMenu: true,
      disableReorder: true,
      filterable: false,
      hideSortIcons: true,
      sortable: false,
      renderHeader: (params: GridColumnHeaderParams) => (
        <></>
      ),
      renderCell: (params) => (
        <Box sx={{
          width: '100%', display: 'flex', justifyContent: 'flex-end', pr: '15px',
        }}>
          <Button
            variant="text"
            endIcon={<ArrowRightAlt />}
            sx={{
              textTransform: 'none',
            }}
            onClick={() => navigate(`/municipalities/${params.row.id}`)}
          >
            {params.value}
          </Button>
        </Box>
      ),
    },
  ];

  useEffect(() => {
    if (municipalities) {
      const municipalitiesRowsTemp: any[] = [];
      municipalities.forEach((municipality:any) => {
        municipalitiesRowsTemp.push(
          {
            ...municipality,
            link: 'consulter',
          },
        );
      });
      setRows(municipalitiesRowsTemp);
    }
  }, [municipalities]);

  return (
    <>
      <Box sx={{
        width: '100%',
        height: 1000,
        maxHeight: '100%',
      }}>
        <DataGrid
          rows={rows}
          columns={columns}
          pageSize={100}
          rowsPerPageOptions={[]}
          experimentalFeatures={{ newEditingApi: true }}
          disableSelectionOnClick
          localeText={frFR.components.MuiDataGrid.defaultProps.localeText}
          sx={{
            border: 'none',
            '.MuiDataGrid-row': {
              background: 'rgba(255,255,255,0.8)',
            },
            '.MuiDataGrid-row:nth-of-type(2n)': {
              background: 'rgba(255,255,255,0.2)',
            },
            '&.MuiDataGrid-root .MuiDataGrid-cell:focus': {
              outline: 'none',
            },
          }}
        />
      </Box>
    </>);
};

export default MunicipalitiesTable;
